<template>
	<a-dropdown
		:trigger="actions ? ['click'] : []"
		:class="actions ? 'pointer' : ''"
	>
		<a-tag
			v-if="data.PresupuestoEstado===0"
			:color="$colors.warning"
		>
			<fa-icon
				:icon="['fas','clock']"
				class="mr-2"
			/>
			Pendiente
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>

		<a-tag
			v-else-if="data.PresupuestoEstado===1"
			:color="$colors.success"
		>
			<fa-icon
				:icon="['fas','check']"
				class="mr-2"
			/>
			Aprobado
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>

		<a-tag
			v-else-if="data.PresupuestoEstado===2"
			:color="$colors.danger"
		>
			<fa-icon
				:icon="['fas','sad-tear']"
				class="mr-2"
			/>
			Rechazado
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>

		<a-tag v-else>
			???
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>

		<a-menu slot="overlay">
			<a-menu-item
				key="0"
				@click="setBudgetStatus(0,'pendiente')"
			>
				<span class="text-warning">
					<fa-icon
						:icon="['fas','clock']"
						class="mr-2"
					/> Pendiente
				</span>
			</a-menu-item>
			<a-menu-item
				key="1"
				@click="setBudgetStatus(1,'aprobado')"
			>
				<span class="text-success">
					<fa-icon
						:icon="['fas','check']"
						class="mr-2"
					/> Aprobado
				</span>
			</a-menu-item>
			<a-menu-item
				key="2"
				@click="setBudgetStatus(2,'rechazado')"
			>
				<span class="text-danger">
					<fa-icon
						:icon="['fas','sad-tear']"
						class="mr-2"
					/> Rechazado
				</span>
			</a-menu-item>
		</a-menu>
	</a-dropdown>
</template>

<script>
export default {
	name: 'BudgetStatus',
	props: {
		data: {
			type: Object,
			required: true
		},
		actions: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		async setBudgetStatus(value, text) {
			const result = await this.$gestios.items('presupuestos').edit({
				id: this.data._EntityId,
				params: {
					PresupuestoEstado: value
				}
			});

			if (result.ok) {
				this.$message.success(`El presupuesto ha cambiado a ${text}`);
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
